import {
    GETUSERWITHDRWALCOUNT_SUCCESS,
    GETUSERWITHDRWALCOUNT_FAILED,
    RESET_GETUSERWITHDRWALCOUNT,
    LOADING_GETUSERWITHDRWALCOUNT,
    NETWORK_ERROR_GETUSERWITHDRWALCOUNT,
} from "../types/index";
import { partnerServices } from "../../config/axios";

const resetGetUserWithdrawalcount = () => {
    return { type: RESET_GETUSERWITHDRWALCOUNT };
};

const getUserWithdrawalcount = (userData, authTokenIs) => async (dispatch) => {
    dispatch({ type: LOADING_GETUSERWITHDRWALCOUNT });
    await partnerServices
        .post("getUserWithDrawalCountList", userData, { headers: { AuthToken: authTokenIs } })
        .then((res) => {
            switch (res.data.status) {
                case "success":
                    dispatch(getUserWithdrawalcountsuccess(res.data));
                    break;
                default:
                    dispatch(getUserWithdrawalcountFailed(res.data));
                    break;
            }
        })
        .catch((err) => {
            dispatch({ type: NETWORK_ERROR_GETUSERWITHDRWALCOUNT, payload: err });
        });
};
function getUserWithdrawalcountsuccess(data) {
    return {
        type: GETUSERWITHDRWALCOUNT_SUCCESS,
        payload: data,
    };
}
function getUserWithdrawalcountFailed(data) {
    return {
        type: GETUSERWITHDRWALCOUNT_FAILED,
        payload: data,
    };
}

export { resetGetUserWithdrawalcount, getUserWithdrawalcount };
